export class StorageKeys {
  static HASHVERSION: string = 'hash-version';
  static HEADQUARTER: string = 'dea-headquarter';
  static SESSION: string = 'dea-session';
  static WELCOMEMESSAGE: string = 'welcome-message';
}
